export default __webpack_public_path__ + "static/media/03_Eschweiler_photographer_Esche_Serum114_Architecture_Interieur_2.06ebda74.jpg";